import { render, staticRenderFns } from "./DeletedTable.vue?vue&type=template&id=2de270d7&"
import script from "./DeletedTable.vue?vue&type=script&lang=js&"
export * from "./DeletedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports